import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ThemeState {
  dark: boolean;
  toggle: () => void;
  set: (dark: boolean) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      dark: false,
      toggle: () =>
        set((s) => {
          const next = !s.dark;
          applyTheme(next);
          return { dark: next };
        }),
      set: (dark: boolean) => {
        applyTheme(dark);
        set({ dark });
      },
    }),
    { name: 'apex-theme' }
  )
);

function applyTheme(dark: boolean) {
  if (dark) {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
}

// Apply on load
const stored = localStorage.getItem('apex-theme');
if (stored) {
  try {
    const parsed = JSON.parse(stored);
    if (parsed?.state?.dark) {
      document.documentElement.classList.add('dark');
    }
  } catch {}
}
